





















































































import { Component, Vue } from 'vue-property-decorator';
import startOfDay from "date-fns/startOfDay";
import endOfDay from "date-fns/endOfDay";
import dateFormat from "date-fns/format";
import {
    StoreVisit
} from "@/types";
import {CloudFunctions} from "@/environment";

@Component
export default class StoreVisits extends Vue {

    loading: boolean = false;

    storeVisits: any = [];

    selectedKey: string = null;

    DateFormat = dateFormat;

    startDateModel = new Date();
    endDateModel = new Date();

    mounted() {
        this.onDateChange();
    }

    async onDateChange() {

        const beginningDate = startOfDay(this.startDateModel);
        const endingDate = endOfDay(this.endDateModel);

        this.loading = true;

        try {
            const response = await fetch(`${CloudFunctions}/store_visits`, {
                method: "POST",
                body: JSON.stringify({
                    start: beginningDate.getTime(),
                    end: endingDate.getTime(),
                    technician: null,
                    locations: []
                }),
                credentials: 'same-origin',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                }
            });

            let storeVisits: StoreVisit[] = await response.json();

            storeVisits = storeVisits.sort((a, b) => { return a.displayName.localeCompare(b.displayName) });

            const map = {};

            for(const visit of storeVisits) {
                if(!map[visit.displayName]) {
                    map[visit.displayName] = {
                        visits: []
                    };
                }

                map[visit.displayName].visits.push(visit);
            }

            this.storeVisits = map;
        } catch (e) {
            console.error(e);
        } finally {
            this.loading = false;
        }
    }

    viewDetailedStoreVisits(key: string) {
        this.selectedKey = key;
        (this.$refs["view-store-visits-modal"] as any).show();
    }

}
